import React, { Fragment, useMemo } from 'react';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import buildMerchGroupCategoryBreadcrumbs from '@lib/merchGroup/buildMerchGroupCategoryBreadcrumbs';
import classNames from 'classnames';
import {
  IBreadcrumbsProps,
  IVendorBreadcrumbProps,
  ITaxonomyCategoryBreadcrumbProps
} from './i-breadcrumbs';
import styles from './ProductBreadcrumbs.module.scss';

const trackShopLinkClicks = (
  vendorVariantId: string,
  href: string
) => {
  analyticsTrack('shop_link_clicked', {
    vendorVariantId,
    href
  });
};

export default function ProductBreadcrumbs({
  vendor,
  vendorVariantId,
  merchGroupCategory,
  className = undefined
}: IBreadcrumbsProps) {
  return (
    <div className={classNames(className, styles.Breadcrumbs)}>
      <a
        className={`${styles.Breadcrumb}`}
        href={'/shop'}
        onClick={ () => trackShopLinkClicks(vendorVariantId, '/shop') }
      >
        Shop
      </a>
      <VendorBreadcrumb
        vendor={vendor}
        vendorVariantId={vendorVariantId}
      />
      <TaxonomyCategoryBreadcrumbs
        vendorVariantId={vendorVariantId}
        merchGroupCategory={merchGroupCategory}
      />
    </div>
  );
}

function VendorBreadcrumb({
  vendor,
  vendorVariantId
}: IVendorBreadcrumbProps) {
  if (!vendor) {
    return null;
  }

  return (
    <>
      {vendor?.publicBrandUrl ? (
        <a
          data-test="product-sidebar_breadcrumbs_public-brand-url"
          className={styles.Breadcrumb}
          href={ vendor.publicBrandUrl }
          onClick={ () => trackShopLinkClicks(vendorVariantId, vendor.publicBrandUrl!) }
        >
          <span data-test="product-sidebar_breadcrumbs">
            {vendor.name}
          </span>
        </a>
      ) : (
        <span
          className={styles.Breadcrumb}
          data-test="product-sidebar_breadcrumbs"
        >
          {vendor.name}
        </span>
      )}
    </>
  );
}

function TaxonomyCategoryBreadcrumbs({
  vendorVariantId,
  merchGroupCategory
}: ITaxonomyCategoryBreadcrumbProps) {
  const breadcrumbs = useMemo(() => {
    return buildMerchGroupCategoryBreadcrumbs(merchGroupCategory);
  }, [merchGroupCategory]);

  if (!merchGroupCategory) {
    return null;
  }

  return (
    <>
      {breadcrumbs.map((breadcrumb) => {
        return (
          <Fragment key={breadcrumb.slug}>
            <a
              data-test="product-sidebar_taxonomy-category-breadcrumb"
              className={styles.Breadcrumb}
              href={breadcrumb.slug}
              onClick={ () => trackShopLinkClicks(vendorVariantId, breadcrumb.slug) }
            >
              {breadcrumb.title}
            </a>
          </Fragment>
        );
      })}
    </>
  );
}
